module.exports = __webpack_public_path__ + "assets/img/tx12g.09924606.jpg";